import React from 'react';
import { ACLAuthorizationRequest } from '@/api/bol';
import { LogisticsObjectFormDialog } from '@/components/common/LogisticsObjectFormDialog';
import { defaultConsignmentTemplate } from '@/utils/consignmentDefaultTemplate';

export interface ConsignmentFormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { memberIdentifier: string; consignmentJson: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => Promise<void>;
}

export const ConsignmentFormDialog: React.FC<ConsignmentFormDialogProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const handleSubmit = async (data: { memberIdentifier: string; jsonData: string; consignmentJson?: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => {
    const transformedData = {
      memberIdentifier: data.memberIdentifier,
      consignmentJson: data.consignmentJson || data.jsonData,
      aclAuthorizations: data.aclAuthorizations,
    };

    await onSubmit(transformedData);
  };

  return (
    <LogisticsObjectFormDialog
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Create New Consignment"
      jsonFieldName="consignmentJson"
      defaultJsonTemplate={defaultConsignmentTemplate()}
      jsonLabel="Enter a valid Consignment JSON according to the SDL schema:"
      jsonHelperText="The JSON must conform to the Consignment schema defined in the BOL API"
      submitButtonText="Create"
    />
  );
};
